/**
 * JWT Request and Response Interceptor
 * Menginjeksi Authorization Bearer token otomatis pada setiap outgoing request
 * dan menangani respons 401 (Expired) & 403 (Forbidden)
 */
export function attachJwtInterceptor(axiosInstance) {
    if (!axiosInstance || !axiosInstance.interceptors) {
        return axiosInstance;
    }

    // Request Interceptor: Lampirkan header Authorization
    axiosInstance.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem('jwt_token');
            if (token) {
                config.headers = config.headers || {};
                config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    // Response Interceptor: Tangani 401 (Expired/Unauthorized) & 403 (Forbidden)
    axiosInstance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response) {
                const status = error.response.status;

                if (status === 401) {
                    const hasToken = localStorage.getItem('jwt_token');
                    if (hasToken) {
                        localStorage.removeItem('jwt_token');
                        localStorage.removeItem('token_type');
                        localStorage.removeItem('user_role');
                        localStorage.removeItem('icmb');
                        alert('Sesi Anda telah kedaluwarsa. Silakan login kembali.');
                        window.location.replace('/');
                    }
                } else if (status === 403) {
                    const msg = (error.response.data && error.response.data.message)
                        ? error.response.data.message
                        : 'Akses Ditolak: Anda tidak memiliki izin untuk melakukan aksi ini.';
                    alert(msg);
                }
            }
            return Promise.reject(error);
        }
    );

    return axiosInstance;
}

export default attachJwtInterceptor;
